import React from 'react';
import PropTypes from 'prop-types';

import { ChapterPage } from '../../partials';

export const WrappingContentChapter = ({ name }) => (
  <ChapterPage title={name}>
    <p>
      Now that we have some photos, let&rsquo;s figure out some cool ways to
      present them. We&rsquo;re going to use flexbox to fill up different
      containers with photos, while preserving the way each individual photo
      looks.
    </p>
  </ChapterPage>
);

WrappingContentChapter.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/chapters/WrappingContentChapter.js